import { useDoesUserHaveRole } from "../../../hooks/permissions";
import { UserRole } from "../../../utils/types/user";

export function useCanCreateNote() {
    return useDoesUserHaveRole([
        UserRole.PROVIDER,
        UserRole.SUPER_ADMIN,
        UserRole.SUPPORT_GENERAL,
        UserRole.SUPPORT_ADMIN,
    ]);
}
